
import { XIcon } from 'vue-feather-icons';
import cartMixin from '@/mixins/cartMixin.js';
export default {
  mixins: [cartMixin],
  components: {
    XIcon,
  },
  props: {
    promocode: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    removeCodePromo(idPromoCode) {
      this.cartService
        .removeCodePromo({
          idPromoCode,
          idCart: this.cart.IdCart,
        })
        .then(async (data) => {
          this.cartService.fetchCart();
        })
        .catch((err) => {});
    },
  },
};
